import { AssignableRecipient, User, UserMin } from '@apiContract';

export const isAssignableRecipient = (
  obj: AssignableRecipient | User | UserMin | null | undefined,
): obj is AssignableRecipient => !!obj && 'userId' in obj;

export const getRecipientFullName = (
  recipient: AssignableRecipient | User | UserMin | null | undefined,
  showMiddleName?: boolean,
): string => {
  if (!recipient) return '';

  if (isAssignableRecipient(recipient)) {
    if (recipient.groupId) return recipient.displayName || '';
    const userType = recipient.user;
    if (!userType) return recipient.displayName || '';
    if (showMiddleName && userType.displayName) return userType.displayName;
    return (
      [userType.firstName, userType.lastName].filter(Boolean).join(' ') ||
      userType.displayName ||
      recipient.displayName ||
      ''
    );
  }

  if (showMiddleName && recipient.displayName) return recipient.displayName;
  return [recipient.firstName, recipient.lastName].filter(Boolean).join(' ') || recipient.displayName || '';
};

export const getRecipientInitials = (recipient: AssignableRecipient | User | UserMin | null | undefined): string => {
  if (!recipient) return '';
  if (isAssignableRecipient(recipient)) {
    if (recipient.groupId || !recipient.user) return '';
    return [recipient.user.firstName?.charAt(0), recipient.user.lastName?.charAt(0)].filter(Boolean).join('');
  }
  return [recipient.firstName?.charAt(0), recipient.lastName?.charAt(0)].filter(Boolean).join('');
};
